export const cloudinaryVideoSrc = (filename: string): string => {
  return filename.replace('fetch/', 'upload/');
};

export const getVideoPosterUrl = (public_id: string): string => {
  return `https://res.cloudinary.com/bergenske/video/upload/v1686215734/${public_id}.jpg`;
};
